module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-9-d4e727335c572ccc9c50e28e54b59b40.png";